<template>
  <div class="row">
    <div class="col-md-12 mt50 referencia">   
      <div class="proyecto">
        <div class="row">
          <div class="col-md-8">              
            <h4 class="title mb0">{{ getAriadna }}</h4>
            <h4 class="mt10">{{ $t('Sustituciones') }}</h4>
          </div>  
          <div class="col-md-4">
            <h4 class="title mb0">&nbsp;</h4>
            <div class="download-excel align-right mb10">
              <a :href=" getEnlaceExcel " class="buy-link todo" target="_blank"><i class="fa fa-file-excel-o"></i> {{ $t('Guardar') }} EXCEL</a>
            </div>
          </div>          
        </div>

        <div class="row">
          <div class="col-md-12">
            <router-link :to=" { name: 'consultas-pedido-referencia', params: { idConsorcio: getIdConsorcio, referencia: getReferencia } } " class="consultas-link"><i class="fa fa-angle-left"></i></router-link>
            
            <router-link :to="{ name: 'sustituciones-con-propuestas' }" class="consultas-link" active-class="active">
              {{ $t('Pendientes') }} <span class="pl5">( {{ getSustitucionesCantidades.pendientes }} )</span>
            </router-link>
            <router-link :to="{ name: 'sustituciones-sin-propuestas' }" class="consultas-link" active-class="active">
              {{ $t('Sin propuesta') }} <span class="pl5">( {{ getSustitucionesCantidades.sinPropuestas }} )</span>
            </router-link>
            <router-link :to="{ name: 'sustituciones-rechazadas' }" class="consultas-link" active-class="active">
              {{ $t('Rechazadas') }} <span class="pl5">( {{ getSustitucionesCantidades.rechazados }} )</span>
            </router-link>
            <router-link :to="{ name: 'sustituciones-aceptadas' }" class="consultas-link" active-class="active">
              {{ $t('Aceptadas') }} <span class="pl5">( {{ getSustitucionesCantidades.aceptados }} )</span>
            </router-link>
          </div>
          
        </div>  

        <router-view></router-view>

      </div>         
    </div>
  </div>
</template>

<i18n>
  {
    "es": {
      "Guardar": "Guardar",
      "Sustituciones": "Sustituciones",
      "Con propuesta": "Con propuesta",
      "Pendientes": "Pendientes",
      "Sin propuesta": "Sin propuesta",
      "Rechazadas": "Rechazadas",
      "Aceptadas": "Aceptadas"
    },
    "en": {
    },
    "ca": {
      "Guardar": "Guardar",
      "Sustituciones": "Substitucions",
      "Con propuesta": "Amb proposta",
      "Pendientes": "Pendents",
      "Sin propuesta": "Sense proposta",
      "Rechazadas": "Rebutjades",
      "Aceptadas": "Acceptades"
    }
  }
</i18n>

<script>
  import axios from 'axios'; 
  import { mapGetters, mapMutations } from 'vuex';

  export default {
    data: () => {
      return{
        nombre_consorcio: '',
        enlaceExcel: '',
        error: false,
        error_message: ''
      }
    },
    created(){
      this.cargarDatos()
    },
    mounted(){
      window.scrollTo(0, 0)

    },
    computed:{
      ...mapGetters(['getLocale', 'getApiUrl', 'getIdConsorcio', 'getReferencia', 'getUserRole', 'getActiveBiblioteca', 'getSustitucionesCantidades']),
      getAriadna: function(){
        let consorcio;
        let referencia;

        referencia = ( this.getReferencia == null ) ? ' > ' + this.$t('Todos') : ' > ' + this.getReferencia;        
        
        return this.nombre_consorcio + referencia;
      },
      getEnlaceExcel: function() {
        return this.getApiUrl + this.getLocale + '/misconsultas/sustituciones/excel?id_consorcio=' + this.getIdConsorcio + '&referencia=' + this.getReferencia + '&excel' 
      }
    },
    methods: {
      ...mapMutations(['setSustitucionesCantidades']),
      cargarDatos(){
        axios.get( this.getApiUrl + this.getLocale + '/misconsultas/sustituciones/consorcio?id_consorcio=' + this.getIdConsorcio + '&referencia=' + this.getReferencia)
          .then( (respuesta) =>{ 
            //console.log(respuesta.data.data)
            this.nombre_consorcio = respuesta.data.data.nombre_consorcio

            this.$store.commit('setSustitucionesCantidades',{
              pendientes: respuesta.data.data.pendientes,
              sinPropuestas: respuesta.data.data.sin_propuestas,
              rechazados: respuesta.data.data.rechazados,
              aceptados: respuesta.data.data.aceptados
            })
          })
        .catch( (error) =>{ 
          this.error_message = error.response.data.msg;
          this.error = true;
        });
      },
    },
    watch: {
      /* $route (to, from){
        this.cargarDatos()
      } */
    },
  }
</script>
